var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"list"},[_vm._t("infinite-scroll-list"),_c('div',{ref:"scrollMonitorEl"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }